import { useContext } from "react";
import Logo from "../components/mainPage/Logo";
import '../style/pages/payment.css'
import { Navigate } from "react-router-dom";
import { auth } from "../context/auth";
import { useTranslation } from "react-i18next";

export default function PaymentPage() {
    const { user } = useContext(auth);
    const { t } = useTranslation();
    const LogOut = () => {
            document.cookie = "token=; Max-Age=0; path=/";
            window.location.href = "/";
    }
    return (
        user.data.length === 0 ?
            <Navigate to={'/'} replace />
        :
        <div className="payment flex flex-center-center">
            <div>
                <Logo mode="dark" width="25" flex={true}/>
            <h2>welcome master {user?.data[0]?.name || " "}</h2>
            <p>
                {t("common:messageCollectionForUnpayment", {
                    firstName: user?.data[0]?.name.split(" ")[0] || " ",
                    amount: user.payment.details.pay,
                    planName: user.payment.details.planName
                })}
            </p>
            <div className="decide flex flex-center-center">
                <button onClick={() => LogOut()}>{t("action:exit")}</button>
                <button>{t("action:payNow")}</button>
                <button>{t("action:callCenter")}</button>
            </div>
            </div>
        </div>
    )
}